export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 6v2.616c1.392.504 2.4 1.824 2.4 3.384v8.4c0 1.992-1.608 3.6-3.6 3.6H4.2a3.595 3.595 0 01-3.6-3.6V12c0-1.56 1.008-2.88 2.4-3.384V6c0-3.312 2.688-6 6-6s6 2.688 6 6zm-2.4 0c0-1.98-1.62-3.6-3.6-3.6A3.61 3.61 0 005.4 6v2.4h7.2V6zm1.2 15.6c.66 0 1.2-.54 1.2-1.2V12c0-.66-.54-1.2-1.2-1.2H4.2c-.66 0-1.2.54-1.2 1.2v8.4c0 .66.54 1.2 1.2 1.2h9.6zm-3-5.4a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "18",
    "height": "24",
    "viewBox": "0 0 18 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};